export default "__VITE_ASSET__CU8iW3_5__"